module.exports = __webpack_public_path__ + "img/banner_covid_vertical.f4f91458.jpg";